import React from 'react';
import PropTypes from 'prop-types';

const CIN = props => {

  return (
    <svg
      width={40}
      height={40}
      preserveAspectRatio="xMidYMid slice"
      clipRule="evenodd"
      fillRule="evenodd"
      viewBox="0 0 560 400"
      xmlns="http://www.w3.org/2000/svg"
      id="Bengals"
    >
      <path
        d="m393.04 196.711c-1.499-.761-1.312-2.117-.233-2.924 12.742-9.463 21.457-21.643 21.457-40.382 0-22.206-15.929-53.406-78.047-53.406h-160.218l-36.26 63.244h26.609c2.98 0 5.379 2.399 5.379 5.368v63.057c0 2.97-2.399 5.368-5.379 5.368h-28.576l36.635 62.962 169.587-.02c54.624 0 78.234-28.483 78.234-59.121 0-20.239-14.429-36.729-29.045-44.13"
        fill="#fff"
      />
      <path
        d="m298.409 186.405h-26.329v-25.297c.025-2.651 2.175-4.797 4.835-4.797h21.456c12.649 0 17.24 6.427 17.24 14.803 0 8.901-4.685 15.272-17.24 15.272zm0 58.278h-21.456c-2.67 0-4.835-2.164-4.835-4.825v-25.298h26.329c12.649 0 17.24 6.175 17.24 14.804 0 8.882-4.685 15.272-17.24 15.272zm75.143-46.098c-1.93-.454-1.611-2.82-.202-3.345 17.333-6.577 27.546-18.27 27.546-38.882.241-27.641-24.173-46.66-63.9-46.66h-150.847l-26.422 46.66h18.177c3.597 0 6.502 2.904 6.502 6.502v75.33c0 3.597-2.905 6.502-6.502 6.502h-17.99l26.609 46.472 157.407-.02c44.974 0 63.431-29.888 63.431-51.813 0-19.302-14.241-35.979-34.011-40.758"
        fill="#fb4f14"
      />
      <path d="m237.508 278.225c-27.921-52.469-35.229-112.432-24.829-168.65h-26.422l-26.422 46.66h18.177c3.598 0 6.503 2.905 6.503 6.502v57.81c13.585 22.018 33.168 43.099 52.937 57.341zm132.109-163.028c-31.95 47.409-49.283 107.748-41.507 163.028 9.557-46.285 34.386-89.009 73.082-119.928.01-.46.05-.905.05-1.377.163-19.02-11.43-34.011-31.575-41.508zm-53.593-5.191c-5.013 13.118-10.306 28.952-14.71 46.754-.791-.059-1.63-.094-2.493-.094h-21.456c-2.661 0-4.806 2.136-4.834 4.797v25.298h22.58c-1.489 9.078-2.698 18.457-3.504 28.108h-19.113v25.297c0 2.67 2.164 4.826 4.834 4.826h13.211c.198 15.178 1.546 30.731 4.385 46.378h-19.675c-15.459-37.385-36.822-100.253-15.647-181.767h56.31" />
    </svg>
  );
};

CIN.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

CIN.defaultProps = {
  size: '100'
};

export default CIN;
